import storage from '../../services/stoage.service'
import utils from '../../utils'

const PREFIXO = 'agendamentorelatorio.label.'

/** Os textos 'agendamentorelatorio' do dicionario (carregados no login). Le e faz o parse do localStorage. */
export const textosAgendamento = () => storage.getAppLabels('agendamentorelatorio')

/**
 * Texto 'agendamentorelatorio.label.<chave>'. Quem renderiza muitas vezes (listagem, dialogo) passa os textos ja
 * carregados em {@code textos}, para nao refazer o parse do dicionario a cada chamada.
 */
export const textoAgendamento = (chave, textos = textosAgendamento()) => utils.getMessage(textos, PREFIXO + chave)
